"use client"

import { LazyMotion, domAnimation, m, AnimatePresence } from "framer-motion"
import type { ReactNode } from "react"

/** Use `motion` (not the full `motion` export) under LazyMotion — skips layout
 *  projection, drag, and other features Lighthouse flags as unused on this site. */
export { m as motion, AnimatePresence }

export function MotionRoot({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  )
}
